import { textUtils } from '@instinet-analytics/core-lib';

const { isFalsyOrWhitespace } = textUtils;

const LayoutNameRegex = /^[a-zA-Z0-9]([a-zA-Z0-9 _!$&',.;:+@~]|-)*$/;

export function isLayoutNameValid(layoutName: string): {
    isValid: boolean;
    message?: string;
} {
    if (isFalsyOrWhitespace(layoutName)) {
        return invalid('Please enter a layout name');
    }

    if (!LayoutNameRegex.test(layoutName)) {
        return invalid('The entered layout name is invalid');
    }

    if (layoutName.length > 100) {
        return invalid('The layout name cannot exceed 100 characters');
    }

    return { isValid: true };
}

function invalid(message: string): { isValid: boolean; message: string } {
    return { isValid: false, message };
}
